import { tokenStorage, userStorage } from 'local-storage/globle';

import {
  signInApi,
  createResetPasswordCodeApi,
  verifyResetPasswordCodeApi,
  resetPasswordApi,
} from './auth.api';

export const signInReducers = (builder) => {
  builder
    .addCase(signInApi.fulfilled, (state, { payload }) => {
      const { token, user } = payload?.data;
      const { keepUserLoggedIn } = payload;

      if (keepUserLoggedIn) {
        tokenStorage().set('token', token);
        userStorage().set('user', user);
      } else {
        tokenStorage('session').set('token', token);
        userStorage('session').set('user', user);
      }

      state.token = token;
      state.signInStatus = 'successful';
      state.signInMessage = '';
    })
    .addCase(signInApi.pending, (state) => {
      state.signInStatus = 'pending';
      state.signInMessage = '';
    })
    .addCase(signInApi.rejected, (state, { payload }) => {
      state.signInStatus = 'failed';
      state.signInMessage =
        payload?.status === 401
          ? 'User not found'
          : payload?.message || 'We ran into a problem. Please try again.';
    });
};

export const createResetPasswordCodeReducers = (builder) => {
  builder
    .addCase(createResetPasswordCodeApi.fulfilled, (state) => {
      state.forgotPasswordStatus = 'successful';
      state.forgotPasswordMessage = '';
    })
    .addCase(createResetPasswordCodeApi.pending, (state) => {
      state.forgotPasswordStatus = 'pending';
      state.forgotPasswordMessage = '';
    })
    .addCase(createResetPasswordCodeApi.rejected, (state, { payload }) => {
      state.forgotPasswordStatus = 'failed';
      state.forgotPasswordMessage =
        payload?.status === 401
          ? 'User not found'
          : payload?.message || 'We ran into a problem. Please try again.';
    });
};

export const verifyResetPasswordCodeReducers = (builder) => {
  builder
    .addCase(verifyResetPasswordCodeApi.pending, (state) => {
      state.verifyCodeStatus = 'pending';
      state.verifyCodeMessage = '';
    })
    .addCase(verifyResetPasswordCodeApi.fulfilled, (state, { payload }) => {
      state.resetPasswordToken = payload?.token;

      state.verifyCodeStatus = 'successful';
      state.verifyCodeMessage = '';
    })
    .addCase(verifyResetPasswordCodeApi.rejected, (state, { payload }) => {
      state.verifyCodeStatus = 'failed';
      if (payload?.status === 410) {
        state.verifyCodeMessage = 'Code expired';
      } else {
        state.verifyCodeMessage =
          payload?.message || 'We ran into a problem. Please try again.';
      }
    });
};

export const resetPasswordReducers = (builder) => {
  builder
    .addCase(resetPasswordApi.fulfilled, (state) => {
      state.resetPasswordStatus = 'successful';
      state.resetPasswordMessage = '';
    })
    .addCase(resetPasswordApi.pending, (state) => {
      state.resetPasswordStatus = 'pending';
      state.resetPasswordMessage = '';
    })
    .addCase(resetPasswordApi.rejected, (state, { payload }) => {
      state.resetPasswordStatus = 'failed';
      if (payload?.status === 401) {
        state.resetPasswordMessage = 'Code invalid or expired';
      } else {
        state.resetPasswordMessage =
          payload?.message || 'We ran into a problem. Please try again.';
      }
    });
};
